const PIE_PIECE_DEFAULT_COLOR = 'signal-gray-30';
const PIE_DEFAULT_CX_VALUE = '50%';
const PIE_DEFAULT_CY_VALUE = '50%';
export { PIE_PIECE_DEFAULT_COLOR, PIE_DEFAULT_CX_VALUE, PIE_DEFAULT_CY_VALUE, };
//# sourceMappingURL=pie-chart-constants.js.map